import React, { useEffect, useState } from 'react'
import AddNewLedger from './AddNewLedger';
import spinner from "../../images/reports-spinner.gif";

export default function AccountLedger() {
  const [modal, setModal] = useState(false);
  const [editData, setEditData] = useState();
  const [ledgers, setLedgers] = useState([]);
  const [ledgerGroups, setLedgerGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const close = () => setModal(!modal);

  useEffect(() => {
    setLoading(true);
    const getLedgers = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/acLedger/ListLedger`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          setLedgers(data);
          setLoading(false);
        })
        .catch(err => console.warn("post request failed", err));
    }
    const getLedgerGroups = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/acLedgerGroup/ListLedgerGroup`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          setLedgerGroups(data);
        })
        .catch(err => console.warn("post request failed", err));
    }
    getLedgerGroups();
    getLedgers();
  }, [modal]);

  return (
    <div className="accountGroup">
      <h1>Ledger</h1>
      <div className="accountGroupOptions">
        <button onClick={() => setModal(!modal)}>+Add New</button>
        <input type="search" placeholder="Search..." />
      </div>

      {loading && <div id="reports-loading-spinner" style={{ top: '87px', zIndex: '1' }}>
        <img src={spinner} alt="loading reports" />
      </div>}
      {!loading && <div className="items_table" style={{ flex: '1', padding: '0 10px' }}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 bb b--black-20">Sr No.</th>
              <th className="pa2 bb b--black-20">Ledger</th>
              <th className="pa2 bb b--black-20">Ledger Group</th>
              <th className="pa2 bb b--black-20">Balance</th>
              <th className="pa2 bb b--black-20">Action</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {ledgers.length > 0 && ledgers?.map((data, i) => {
              if (data.ledger_uuid)
                return <tr key={i.toString()}>
                  <td className="ph2 pv1 tc bb b--black-20 bg-white">{i + 1}</td>
                  <td className="ph2 pv1 tc bb b--black-20 bg-white">{data.ledger_title}</td>
                  <td className="ph2 pv1 tc bb b--black-20 bg-white">{ledgerGroups?.find(a => a.ledger_group_uuid === data.ledger_group_uuid)?.ledger_group_title || '-'}</td>
                  <td className="ph2 pv1 tc bb b--black-20 bg-white">{data.ledger_balance || "-"}</td>
                  <td className="ph2 pv1 tc bb b--black-20 bg-white">
                    <button
                      className='editButton'
                      onClick={() => {
                        setModal(!modal);
                        setEditData(data);
                      }}
                    >Edit</button>
                  </td>
                </tr>
              else
                return ''
            })}
          </tbody>
        </table>
      </div>}

      {modal && (
        <AddNewLedger
          type={!editData ? "New" : "Edit"}
          close={close}
          editData={editData}
        />
      )}
    </div>
  )
}
